import { createApp } from 'vue'
import router from './router.js'

import App from './App.vue'
import GlobalFilters from './helpers/GlobalFilters'
import Modal from '@/components/Modal'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faSpinner, faTag } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import "@/assets/main.scss"

library.add(faSpinner, faTag)

const app = createApp(App)

app.component('modal', Modal)
app.component('fa-icon', FontAwesomeIcon)

app.use(router)


app.config.globalProperties.$filters = GlobalFilters
app.config.globalProperties.$buckets = {
    images: 'https://brandonaguirre-website-images.s3.us-east-2.amazonaws.com'
}

app.mixin({
    methods: {
        getImageUrl (img) {
            return this.$buckets.images + '/' + img
        }
    }
})

app.mount('#app')
